import { useNavigate } from "react-router-dom";
import Form, { FormDefinition, FormData, FieldDefinition } from "../../Components/Form/Form";
import { LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync, useReloadOnOutletSave, useRequiredParams } from "../../utilities/customHooks";
import { adminRecommendationFormDefition, expertAssessmentFormDefition, founderProfileEvaluationFormGroupDefinition, ipeMeetingForm, sowFeedbackExpertFormDefinition, sowFeedbackFormDefinition, t1AssessmentForm, t2CoachAssessmentForm, t2ServiceAssessmentForm, t3serviceAssessmentForm, updatedFounderProfileEvaluationFormGroupDefinition, updatedFounderProfileReadinessEvaluationFormGroupDefinition } from "../../utilities/formDefinitionTemplates";
import Button, { ButtonProp } from "../../Components/Button";
import { daysAgo, flattenObject, getModifiedCompanyInfoFormDef, handleFormSaveResponse } from "../../utilities/helperFunctions";
import { SetStateAction, useContext, useEffect, useState } from "react";
import { getInProgressAssessmentAsync, saveFounderAssessment, submitFounderAssessment, addDDFlag, getMemberDetails, addNewNote, addConflict, saveFounderFullAssessment, sendIpeInvite, addIpeMeeting, setBoardReview, removeBoardReview, saveIpeAssessment, saveIpeRejection, sendSowFeedback, expertApproveSow } from "../../services/ipExpertService";
import * as T from "../../utilities/frontendTypes";
import LoadingIndicator from "../../Components/LoadingIndicator";
import ErrorIndicator from "../../Components/ErrorIndicator";
import Modal from "../../Components/Modal";
import { basic_number_validator, basic_text_validator, selection_validator } from "../../utilities/formFieldValidators";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from "react-accessible-accordion";
import Plus from '../../assets/Plus.png'
import Minus from '../../assets/Minus.png'
import FormGroup from "../../Components/FormGroup";
import { convertFounderProfileDBStateToUIState } from "../../utilities/stateConverters";
import CompanyNotes from "../../Components/ExpertNotes";
import PdfDownloader from "../../Components/Form/pdfDisplayExpert";
import moment from "moment";
import { inputClasses } from "../../Components/Form/InputField";
import NDAUpload from "../../Components/Form/NDAUpload";
import { needHelpWithDefinition, profileFormAdminProgramingEvaluationDefinition, profileFormPersonalInfoDefinition, profileFormProgramingEvaluationDefinition } from "../../utilities/profileFormDefitions";

const FounderAssesmentDetails = () => {
  const navigate = useNavigate();
  const appId = useRequiredParams("id")
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const [reload, setReload] = useState(false);
  const [reloadOnOutletSave, setReloadOnOutletSave] = useState(false);
  const [assessmentForm, setAssessmentForm] = useState<T.ScoreBreakdown | null>(null);
  const [tempUpdatedDDForm, setTempUpdatedDDForm] = useState<FormData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [enteringMeeting, setEnteringMeeting] = useState(false);
  const [submitRec, setSubmitRec] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [duration, setDuration] = useState("");
  const [isDDflag, setIsDDFlag] = useState(false);
  const [tierRec, setTierRec] = useState("");
  const [html, setHtml] = useState(<></>)
  const [isAssessing, setIsAssessing] = useState(false);
  const [viewPdfName, setViewPdfName] = useState("")
  const [isMeetingModal, setIsMeetingModal] = useState(false)
  const [modalHtml, setModalHtml] = useState(<></>)
  const [t1Rec, setT1Rec] = useState("")
  const [t1Score, setT1Score] = useState("")
  const [t1Notes, setT1Notes] = useState("")
  const [t2CoachRec, setT2CoachRec] = useState("")
  const [t2CoachScore, setT2CoachScore] = useState("")
  const [t2CoachNotes, setT2CoachNotes] = useState("")
  const [t2ServiceRec, setT2ServiceRec] = useState("")
  const [t2ServiceScore, setT2ServiceScore] = useState("")
  const [t2ServiceNotes, setT2ServiceNotes] = useState("")
  const [t3ServiceRec, setT3ServiceRec] = useState("")
  const [t3ServiceScore, setT3ServiceScore] = useState("")
  const [t3ServiceNotes, setT3ServiceNotes] = useState("")
  const [t2ServiceArray, setT2ServiceArray] = useState<string[]>([])
  const [t3ServiceArray, setT3ServiceArray] = useState<string[]>([])
  const [viewingSow, setViewingSow] = useState(false)
  const [successStory, setSuccessStory] = useState(false)
  const [successStoryNotes, setSuccessStoryNotes] = useState("")
  const [isNdaModalOpen, setIsNdaModalOpen] = useState(false)
  const [hardCrit, setHardCrit] = useState(false)
  const [notTech, setNotTech] = useState(false)
  const [economicBenefit, setEconomicBenefit] = useState(false)
  const [revScore, setRevScore] = useState(false)
  const [marketReadiness, setMarketReadiness] = useState(false)
  const [ipOwnership, setIpOwnership] = useState(false)
  const [commercialization, setCommercialization] = useState(false)
  const [jobCreation, setJobCreation] = useState(false)
  const [teamFit, setTeamFit] = useState(false)
  const [viewingComplete, setViewingComplete] = useState(false)
  const [recHtml, setRecHtml] = useState(<></>)
  const [workingSowId, setWorkingSowId] = useState("")
  const [sowViewingArrayPosition, setSowViewingArrayPostion] = useState(0)

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setIsDDFlag(false)
    setViewingSow(false)
  }
  const handlePdfStateChange = () => {
    setIsNdaModalOpen(false)
    setReload(!reload)
  };

  const handleCheckboxChange = () => {
    setSuccessStory(!successStory)
  };

  const changeCriteria = (criteria: string) => {
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "notTech") {
      setNotTech(!notTech)
    }
    if (criteria === "economicBenefit") {
      setEconomicBenefit(!economicBenefit)
    }
    if (criteria === "revScore") {
      setRevScore(!revScore)
    }
    if (criteria === "marketReadiness") {
      setMarketReadiness(!marketReadiness)
    }
    if (criteria === "ipOwnership") {
      setIpOwnership(!ipOwnership)
    }
    if (criteria === "hardCrit") {
      setHardCrit(!hardCrit)
    }
    if (criteria === "commercialization") {
      setCommercialization(!commercialization)
    }
    if (criteria === "jobCreation") {
      setJobCreation(!jobCreation)
    }
    if (criteria === "teamFit") {
      setTeamFit(!teamFit)
    }
  }

  useEffect(() => {
    setHtml(<CompanyNotes id={appId}/>)
  }, [appId]);

  const t1RecChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT1Rec(event.target.value);
    if (event.target.value === "reject" || event.target.value === "n/a") {
      setT1Score("");
    }
  };

  const t1ScoreChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT1Score(event.target.value);
  };

  const t2CoachRecChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2CoachRec(event.target.value);
    if (event.target.value === "reject" || event.target.value === "n/a") {
      setT2CoachScore("");
      setT2CoachNotes("");
    }
  };

  const t2CoachScoreChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2CoachScore(event.target.value);
  };

  const t2ServiceRecChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2ServiceRec(event.target.value);
    if (event.target.value === "reject" || event.target.value === "n/a") {
      setT2ServiceScore("");
      setT2ServiceArray([])
      setT2ServiceNotes("")
    }
  };

  const t2ServiceScoreChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2ServiceScore(event.target.value);
  };

  const t3ServiceScoreChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT3ServiceScore(event.target.value);
  };

  const t3ServiceRecChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT3ServiceRec(event.target.value);
    if (event.target.value === "reject" || event.target.value === "n/a") {
      setT3ServiceScore("");
      setT3ServiceArray([])
      setT3ServiceNotes("")
    }
  };

  const handleT2ServiceArray = (service: string) => {
    setT2ServiceArray((prev: string[]) =>
      prev.includes(service) ? prev.filter((i) => i !== service) : [...prev, service]
    );
  }

  const handleT1Blur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT1Notes(event.target.value);
  };

  const handleT2CoachBlur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2CoachNotes(event.target.value);
  };

  const handleT2ServiceBlur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT2ServiceNotes(event.target.value);
  };

  const handleT3ServiceBlur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setT3ServiceNotes(event.target.value);
  };
  
  const handleSuccessStoryBlur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setSuccessStoryNotes(event.target.value);
  };

  const allt2Services = [
    "General IP Strategy Development",
    "Trademark/Branding Strategy Session",
    "IP Licensing Strategy Session",
    "Invention Mining/Patent Mining Session and Report",
    "Patentability/Novelty/Prior Art Search",
    "Patent Landscape Report",
    "Trademark Clearance Search - Canada",
    "Trademark Clearance Search - US",
    "Trademark Clearance Search - EU",
    "Trademark Clearance Search - Other jurisdiction",
    "Review of IP clauses/IP ownership",
    "Drafting for IP clauses/IP ownership",
    "Trade Secret Protection Plan",
    "Other"
  ];

  const handleT3ServiceArray = (service: string) => {
    setT3ServiceArray((prev: string[]) =>
      prev.includes(service) ? prev.filter((i) => i !== service) : [...prev, service]
    );
  }

  const allt3Services = [
    "Patent Filing, including initial drafting - Canada",
    "Patent Filing, regular application, including initial drafting - US",
    "Patent Filing, including drafting - EP (EU)",
    "Patent Filing - PCT",
    "Patent Filing, provisional application - US",
    "Converting PCT to CA national filing",
    "Convert PCT to US national filing",
    "Converting US provisional to regular US application",
    "Converting US provisional to PCT",
    "Converting US provisional to other national filing",
    "Patent Prosecution - Responding to Office Action",
    "Paying Notice of Allowance for Patent - CA",
    "Paying Notice of Allowance for Patent - US",
    "Paying Notice of Allowance for Patent - EP (EU)",
    "Paying Notice of Allowance for Patent - Other jurisdiction",
    "Trademark Filing - Canada",
    "Trademark Filing - US",
    "Trademark Filing - Other jurisdiction",
    "Review and/or drafting Licensing agreement",
    "Design Patent/Industrial Design Application - US",
    "Design Patent/Industrial Design Application - Other jurisdiction",
    "Open Source Review and Inventory",
    "Other"  
  ];

  const saveAssessment = async (complete: boolean) => {
    const ipAssessmentObj = {
      t1Rec: t1Rec,
      t1Score: t1Score,
      t1Notes: t1Notes,
      t2CoachRec: t2CoachRec,
      t2CoachScore: t2CoachScore,
      t2CoachNotes: t2CoachNotes,
      t2ServiceRec: t2ServiceRec,
      t2ServiceScore: t2ServiceScore,
      t2ServiceNotes: t2ServiceNotes,
      t3ServiceRec: t3ServiceRec,
      t3ServiceScore: t3ServiceScore,
      t3ServiceNotes: t3ServiceNotes,
      t2ServiceArray: t2ServiceArray,
      t3ServiceArray: t3ServiceArray,
      successStory: successStory,
      successStoryNotes: successStoryNotes
    }
    showLoading();
    const response = await saveIpeAssessment(appId, ipAssessmentObj, complete)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Assessment Saved"});
    setReload(!reload)
    handleBack()
    }
  }

  useEffect(() => {
    setRecHtml(<div className="flex flex-col">
  
    {/* Tier 1 */}
  
    <p className="font-semibold bodyLarger">Tier 1 - Education and Awareness</p>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t1Rec">Recommended Support:</label>
      <select className={`flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full ${inputClasses}`} id="cat1" name="cat1" value={t1Rec} style={{wordWrap: "break-word"}} onChange={t1RecChange}>
        <option disabled value="">Select Recommendation</option>
        <option value="approve">Approve</option>
        <option value="reject">Reject</option>
        <option value="n/a">Not Applicable</option>
      </select>
    </div>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t1Score">Assessment Score:</label>
      <input 
        id="t1Score"
        type="number" 
        value={t1Score} 
        onChange={t1ScoreChange}
        className={inputClasses}
      />
    </div>
    {t1Rec && t1Rec !== "n/a" &&
    <div className="flex flex-col gap-2 w-full">
      <p className="font-semibold mt-2">Notes</p>
      <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={t1Notes} placeholder="Tier 1 Notes..." onBlur={handleT1Blur}></textarea>
    </div>
    }
  
    {/* Tier 2 Coach */}
  
    <p className="font-semibold bodyLarger mt-4">Tier 2 - Coaching</p>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t2CoachRec">Recommended Support:</label>
      <select className={`flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full ${inputClasses}`} id="t2CoachRec" name="t2CoachRec" value={t2CoachRec} style={{wordWrap: "break-word"}} onChange={t2CoachRecChange}>
        <option disabled value="">Select Recommendation</option>
        <option value="approve">Approve</option>
        <option value="reject">Reject</option>
        <option value="n/a">Not Applicable</option>
      </select>
    </div>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t2CoachScore">Assessment Score:</label>
      <input 
        id="t2CoachScore"
        type="number" 
        value={t2CoachScore} 
        onChange={t2CoachScoreChange}
        className={inputClasses}
      />
    </div>
    {t2CoachRec && t2CoachRec !== "n/a" &&
    <div className="flex flex-col w-full gap-2">
      <p className="font-semibold mt-2">Notes</p>
      <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={t2CoachNotes} placeholder="Tier 2 Coaching Notes..." onBlur={handleT2CoachBlur}></textarea>
    </div>
    }
  
    {/* Tier 2 Service */}
  
    <p className="font-semibold bodyLarger mt-4">Tier 2 - Project</p>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t2ServiceRec">Recommended Support:</label>
      <select className={`flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full ${inputClasses}`} id="t2CoachRec" name="t2CoachRec" value={t2ServiceRec} style={{wordWrap: "break-word"}} onChange={t2ServiceRecChange}>
        <option disabled value="">Select Recommendation</option>
        <option value="approve">Approve</option>
        <option value="reject">Reject</option>
        <option value="n/a">Not Applicable</option>
      </select>
    </div>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t2ServiceScore">Assessment Score:</label>
      <input 
        id="t2ServiceScore"
        type="number" 
        value={t2ServiceScore} 
        onChange={t2ServiceScoreChange}
        className={inputClasses}
      />
    </div>
    {t2ServiceRec === "approve" &&
    <div className="flex flex-col w-full">
      <p className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold">Recommended Tier 2 Services:</p>
      <div className="flex flex-col">
        {allt2Services.map((item) => (
          <label className="!flex w-full items-center h-full" key={item} style={{ display: "block", marginBottom: "5px" }}>
            <input
              className="mr-2"
              type="checkbox"
              checked={t2ServiceArray.includes(item)}
              onChange={() => handleT2ServiceArray(item)}
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
    </div>
    }
    {t2ServiceRec && t2ServiceRec !== "n/a" &&
    <div className="flex flex-col w-full gap-2">
      <p className="font-semibold mt-2">Notes</p>
      <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={t2ServiceNotes} placeholder="Tier 2 Project Notes..." onBlur={handleT2ServiceBlur}></textarea>
    </div>
    }
  
    {/* Tier 3 Service */}
  
    <p className="font-semibold bodyLarger mt-4">Tier 3 - Project</p>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t3ServiceRec">Recommended Support:</label>
      <select className={`flex grow p-4 break-word self-center max-w-full overflow-hidden whitespace-normal w-full ${inputClasses}`} id="t3ServiceRec" name="t3ServiceRec" value={t3ServiceRec} style={{wordWrap: "break-word"}} onChange={t3ServiceRecChange}>
        <option disabled value="">Select Recommendation</option>
        <option value="approve">Approve</option>
        <option value="reject">Reject</option>
        <option value="n/a">Not Applicable</option>
      </select>
    </div>
    <div className="flex flex-col w-full">
      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold" htmlFor="t3ServiceScore">Assessment Score:</label>
      <input 
        id="t3ServiceScore"
        type="number" 
        value={t3ServiceScore} 
        onChange={t3ServiceScoreChange}
        className={inputClasses}
      />
    </div>
    {t3ServiceRec === "approve" &&
    <div className="flex flex-col w-full">
      <p className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text my-2 font-semibold">Recommended Tier 3 Services:</p>
      <div className="flex flex-col">
        {allt3Services.map((item) => (
          <label className="!flex w-full items-center h-full" key={item} style={{ display: "block", marginBottom: "5px" }}>
            <input
              className="mr-2"
              type="checkbox"
              checked={t3ServiceArray.includes(item)}
              onChange={() => handleT3ServiceArray(item)}
            />
            <span>{item}</span>
          </label>
        ))}
      </div>
    </div>
    }
    {t3ServiceRec && t3ServiceRec !== "n/a" &&
    <div className="flex flex-col w-full gap-2">
      <p className="font-semibold mt-2">Notes</p>
      <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={t3ServiceNotes} placeholder="Tier 3 Project Notes..." onBlur={handleT3ServiceBlur}></textarea>
    </div>
    }
    <div className="flex flex-col w-full gap-2 mb-6">
    <label className="flex items-center mt-2">
      <input
        className=" mr-2"
        type="checkbox"
        checked={successStory ? true : false}
        onChange={handleCheckboxChange}
      />
      Flag as a potential Success Story?
    </label>
    {successStory &&
    <div className="flex flex-col w-full gap-2">
      <p className="font-semibold">Success Story Notes</p>
      <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={successStoryNotes} placeholder="Tier 3 Project Notes..." onBlur={handleSuccessStoryBlur}></textarea>
    </div>
    }
    </div>
    <div className="flex flex-col gap-4 w-full mb-8">
      <Button
        buttonText="Save Progress"
        actionHandler={() => {saveAssessment(false)}}
        buttonType="secondaryFull"
      />
      <Button
        buttonText="Submit Final Assessment"
        actionHandler={() => {saveAssessment(true)}}
        buttonType="primaryFull"
      />
    </div>
  </div> )}, [t1Rec, t1Score, t1Notes, t2CoachRec, t2CoachScore, t2CoachNotes, t2ServiceRec, t2ServiceScore, t2ServiceNotes, t3ServiceRec, t3ServiceScore, t3ServiceNotes, t2ServiceArray, t3ServiceArray, successStory, successStoryNotes])  

  const saveRejection = async (complete: boolean) => {
    const ipRejectionObj = {
      hardCrit: hardCrit,
      notTech: notTech,
      economicBenefit: economicBenefit,
      revScore: revScore,
      marketReadiness: marketReadiness,
      ipOwnership: ipOwnership,
      commercialization: commercialization,
      jobCreation: jobCreation,
      teamFit: teamFit,
    }
    showLoading();
    const response = await saveIpeRejection(appId, ipRejectionObj, complete)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Assessment Saved"});
    setReload(!reload)
    handleBack()
    }
  }

  const handleInvite = async () => {
    showLoading();
    const response = await sendIpeInvite(appId)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Meeting Invite Sent"});
    setReloadOnOutletSave(!reloadOnOutletSave);
    handleBack()
    setIsModalOpen(false)
    }
  }
  
  const handleBack = () => {
    setIsAssessing(false)
    setEnteringMeeting(false)
    setSubmitRec(false)
    setViewingComplete(false)
    setRejecting(false)
  }

  const assessmentProgCheck = () => {
    if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipAssessmentObj) {
      const progObj = applicationDetails.expertAssessment.ipAssessmentObj
      setT1Rec(progObj.t1Rec || "")
      setT1Score(progObj.t1Score || "")
      setT1Notes(progObj.t1Notes || "")
      setT2CoachRec(progObj.t2CoachRec || "")
      setT2CoachScore(progObj.t2CoachScore || "")
      setT2CoachNotes(progObj.t2CoachNotes || "")
      setT2ServiceRec(progObj.t2ServiceRec || "")
      setT2ServiceScore(progObj.t2ServiceScore || "")
      setT2ServiceNotes(progObj.t2ServiceNotes || "")
      setT3ServiceRec(progObj.t3ServiceRec || "")
      setT3ServiceScore(progObj.t3ServiceScore || "")
      setT3ServiceNotes(progObj.t3ServiceNotes || "")
      setT2ServiceArray(progObj.t2ServiceArray || [])
      setT3ServiceArray(progObj.t3ServiceArray || [])
      setSuccessStory(progObj.successStory || false)
      setSuccessStoryNotes(progObj.successStoryNotes || "")
    }
    if (founderStatus === "complete" || founderStatus === "ipExpertRecommendation" ) {
      setViewingComplete(true)
    } else {
      setSubmitRec(true)
    }
  }

  const assessmentProgCheckOnLoad = () => {
    if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipAssessmentObj) {
      const progObj = applicationDetails.expertAssessment.ipAssessmentObj
      setT1Rec(progObj.t1Rec || "")
      setT1Score(progObj.t1Score || "")
      setT1Notes(progObj.t1Notes || "")
      setT2CoachRec(progObj.t2CoachRec || "")
      setT2CoachScore(progObj.t2CoachScore || "")
      setT2CoachNotes(progObj.t2CoachNotes || "")
      setT2ServiceRec(progObj.t2ServiceRec || "")
      setT2ServiceScore(progObj.t2ServiceScore || "")
      setT2ServiceNotes(progObj.t2ServiceNotes || "")
      setT3ServiceRec(progObj.t3ServiceRec || "")
      setT3ServiceScore(progObj.t3ServiceScore || "")
      setT3ServiceNotes(progObj.t3ServiceNotes || "")
      setT2ServiceArray(progObj.t2ServiceArray || [])
      setT3ServiceArray(progObj.t3ServiceArray || [])
      setSuccessStory(progObj.successStory || false)
      setSuccessStoryNotes(progObj.successStoryNotes || "")
    }
  }

  const checkAndDisplayProgress = () => {
    assessmentProgCheckOnLoad()
    setIsAssessing(true)
  }

  const rejectProgCheck = () => {
    if (applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipRejectionObj) {
      const rejectionObj = applicationDetails.expertAssessment.ipRejectionObj
      setHardCrit(rejectionObj.hardCrit)
      setNotTech(rejectionObj.notTech)
      setEconomicBenefit(rejectionObj.economicBenefit)
      setRevScore(rejectionObj.revScore)
      setMarketReadiness(rejectionObj.marketReadiness)
      setIpOwnership(rejectionObj.ipOwnership)
      setCommercialization(rejectionObj.commercialization)
      setJobCreation(rejectionObj.jobCreation)
      setTeamFit(rejectionObj.teamFit)
    }
    if (founderStatus === "complete" || founderStatus === "ipExpertRecommendation") {
      setViewingComplete(true)
    } else {
      setRejecting(true)
    }
  }

  const boardReview = async () => {
    showLoading();
    const response = await setBoardReview(appId)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Pending Board Review"});
    setReloadOnOutletSave(!reloadOnOutletSave);
    setIsModalOpen(false)
    handleBack()
    }
  }

  const removeReview = async () => {
    showLoading();
    const response = await removeBoardReview(appId)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Pending Board Review"});
    setReloadOnOutletSave(!reloadOnOutletSave);
    setIsModalOpen(false)
    handleBack()
    }
  }

  const handleDurationChange = (event: { target: { value: any; }; }) => {
    const inputValue = event.target.value;
    const newValue = inputValue.replace(/\D/g, '');
    setDuration(newValue);
  };


  useEffect(() => {
    const meetingModalHTML = (
      <div className='flex flex-col text-text'>
        <p>Enter Meeting Duration in minutes:</p>
        <div className="mt-5 mb-5">
        <input
          className={`border ${inputClasses}`}
          type="number"
          value={duration}
          onChange={handleDurationChange}
        />
        </div>
        <div className="flex w-full mt-5 justify-around">
            <Button
              actionHandler={() => setRejecting(true)}
              buttonText="Reject Application"
              buttonType="secondary"
              disabled={duration ? false : true}
            />
            <Button
              actionHandler={() => assessmentProgCheck()}
              buttonText="Submit Recommendation"
              buttonType="secondary"
              disabled={duration ? false : true}
            />  
        </div>
      </div>
    )  
    setModalHtml(meetingModalHTML)
  }, [isMeetingModal, duration]);

  const confirmModal = (updatedForm: FormData) => {
    setIsMeetingModal(true)
    setIsModalOpen(true)
    setAssessmentForm(updatedForm)
  } 

  const memberDetailsAsync = useAsync(() => getMemberDetails(appId), [reloadOnOutletSave, reload]);

  if (memberDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (memberDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const memberDetails = memberDetailsAsync.value.memberDetails
  const applicationDetails = memberDetailsAsync.value.applicationDetails
  let founderProfileGroupData = null
  if (applicationDetails) {
  founderProfileGroupData = convertFounderProfileDBStateToUIState(applicationDetails.profileSnapshot)
  }
  const isUrl = applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("www.")
  const isHttpsUrl =  applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL.includes("https://")
  const urlHref = `https://${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}`
  const websiteHtml = isHttpsUrl ? <a className="underline font-normal mb-2" href={applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : isUrl ? <a className="underline font-normal mb-2" href={urlHref} target="_blank">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</a> : <p className={``}>{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.websiteURL}</p>      
  const ipeRecString = applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.notes ? applicationDetails.expertAssessment.notes : "N/A"
  const ipeRecformData: FormData = {
   rec: ipeRecString
  }
  const inviteDate = applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.inviteDate ? moment(applicationDetails.expertAssessment.inviteDate).format('MMM Do YYYY').toString() : "Invite date not recorded"
  const applicationDate = applicationDetails && applicationDetails.createdAt ? moment(applicationDetails.createdAt).format('MMM Do YYYY').toString() : "Application Date not recorded"
  const updateDate = applicationDetails && applicationDetails.updatedAt ? moment(applicationDetails.updatedAt).format('MMM Do YYYY').toString() : "N/A"
  const owner = applicationDetails && applicationDetails.owner ? applicationDetails.owner.ownerName : "N/A"
  let multiProject = false
  let founderStatus = "complete"
  if (applicationDetails) {
    if (applicationDetails.status === "awaitingIpe") {
      founderStatus = "awaitingIpe"
    } else if (applicationDetails.status === "ipExpertInProgress") {
      founderStatus = "ipExpertInProgress"
    } else if (applicationDetails.status === "ipExpertInvite") {
      founderStatus = "ipExpertInvite"
    } else if (applicationDetails.status === "ipExpertRecommendation") {
      founderStatus = "ipExpertRecommendation"
    } else if (applicationDetails.status === "ipeBoardReview") {
      founderStatus = "ipeBoardReview"
    } else {
      founderStatus = "complete"    
    }
  }
    
  if (memberDetailsAsync.value.project?.statements.some(obj => obj.sowStatus === "Awaiting Expert Approval") || memberDetailsAsync.value.project?.statements.some(obj => obj.sowStatus === "Awaiting Admin Approval") ) {
    founderStatus = "SoW Awaiting Approval"
  }

  const assessed = founderStatus === "complete" || founderStatus === "ipExpertRecommendation" ? "Yes" : "No"

  let docHtml = <div className ="mt-2">No Documents Associated with this company</div>
  const simplifyDocString = (docType: string ) => {
    if (docType.includes("Pitch Deck")) {
      return `${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName} Pitch Deck`
    }
    if (docType.includes("NDA")) {
      return `${applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.operatingName} NDA`
    }
}
  //OLD DOC RETREIVAL WILL NEED TO UPDATE FOR MORE DOCS ON APP I THINK
  if (applicationDetails && applicationDetails.profileSnapshot.documents) {
    const docs = applicationDetails.profileSnapshot.documents as {[key: string]: string;}
    if (docs && docs._id) {
      delete docs._id;
    }
    if (applicationDetails.nda) {
      const ndaString = applicationDetails.nda
      docs[ndaString] = ndaString;
    }
    docHtml =
    <div className="w-full flex flex-col">
    {Object.keys(docs).map((key) => (
        <button key={key} className="flex mt-2 items-center hover:underline" onClick={() => viewPdf(docs[key])}>
          <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="13" height="16" viewBox="0 0 13 16" fill="none"><path d="M12.1253 4.96448V4.85029C12.1253 4.85029 12.1253 4.80514 12.1022 4.80514L12.0341 4.73698L6.36849 0.0230173H6.34547C6.34547 0.0230173 6.32245 0.0230174 6.30032 0H2.71948C1.22341 0 0 1.22341 0 2.71948V13.2805C0 14.7766 1.22341 16 2.71948 16H9.51819C11.0143 16 12.2377 14.7766 12.2377 13.2805V5.07693L12.1253 4.96448ZM6.45967 1.31547L10.4256 4.60151H7.13954C6.75445 4.60151 6.45967 4.30673 6.45967 3.92164V1.31547ZM9.40578 14.9811H2.60707C1.61028 14.9811 0.794081 14.1649 0.794081 13.1681V2.60703C0.794081 1.61025 1.61028 0.794045 2.60707 0.794045H5.55318V3.92164C5.55318 4.80511 6.25607 5.508 7.13954 5.508H11.2188V13.1681C11.2188 14.1649 10.4026 14.9811 9.40578 14.9811Z" fill="#1A2E25"/></svg>
          {simplifyDocString(docs[key])}
        </button>
    ))}
    </div>
  }
  const handlePdfModal = (pdfName: string) => {
  setModalHtml(
    <div className="flex w-full min-w-full">
      <PdfDownloader docKey={pdfName}/>
    </div>
    )
  setIsModalOpen(true)
  }

  const viewPdf = (pdfName: string) => {
    handlePdfModal(pdfName)
  }
  
  const ddFlagForm: FormDefinition = {
    notes: {
      label: "Why are you flagging this company for due dilligence?",
      inputType: "textarea",
      validator: basic_text_validator,
    }
  }

  const confiltOfInterestForm: FormDefinition = {
    notes: {
      label: "Add a note regarding the conflict of interest:",
      inputType: "textarea",
      validator: basic_text_validator,
    }
  }

  const handleAddDDFlag = async (updatedFormData: FormData) => {
    const tempNotes = updatedFormData as any
    const notes = tempNotes.notes
    showLoading();
    const response = await addDDFlag(appId, notes)
    hideLoading();

    if (response.success) {
    handleFormSaveResponse(response, showToast, {message: "Company Flagged for Due Diligence"});
    setReload(!reload)
    setIsModalOpen(false)
    handleBack()
    }
  }

  const saveMeeting = async (updatedFormData: FormData) => {
    const tempData = updatedFormData as any
    const meetingType = tempData.meetingType
    const duration = tempData.duration
    const date = tempData.date
    const notes = tempData.notes
    showLoading();
    const response = await addIpeMeeting(appId, meetingType, duration, date, notes)
    hideLoading();

    if (response.success) {
    handleBack()
    handleFormSaveResponse(response, showToast, {message: "Interaction Logged!"});
    setReload(!reload)
    setIsModalOpen(false)
    handleBack()
    }
  }

  const meetingButtonProp: ButtonProp = {
    buttonText: "Save",
    actionHandler: saveMeeting,
  }

  const handleConflict = async (updatedFormData: FormData) => {
    const tempNotes = updatedFormData as any
    const notes = tempNotes.notes
    showLoading();
    const response = await addConflict(appId, notes)
    hideLoading();
    if (response.success) {
      handleFormSaveResponse(response, showToast, {message: "Conflict of Interested noted.  Company re-added to pool for assessment."});
      navigate("/dashboard")
    }
  }

  const primaryButtonPropDD: ButtonProp = {
    buttonText: "Save",
    actionHandler: handleAddDDFlag,
    buttonType: "primaryFull"
  }

  const primaryButtonConflictOfInterest: ButtonProp = {
    buttonText: "Submit",
    actionHandler: handleConflict,
    buttonType: "primaryFull"
  }

  const flagModalHTML = (
    <div className='flex flex-col w-full'>
      <Form
        formDefinition={ddFlagForm}
        formData={null}
        primaryButtonProp={primaryButtonPropDD}
      />
    </div>
  )

  const conflictOfInterestModalHTML = (
    <div className='flex flex-col w-full'>
      <Form
        formDefinition={confiltOfInterestForm}
        formData={null}
        primaryButtonProp={primaryButtonConflictOfInterest}
      />
    </div>
  )

  const viewComplete = () => {
    if (applicationDetails?.expertAssessment?.ipRejectionObj) {
      rejectProgCheck()
    } else {
      assessmentProgCheck()
    }
  }

  async function approveSoW (workingSowId: string) {
    showLoading();
    const response = await expertApproveSow(workingSowId);
    hideLoading();
    if (response.success) {
      showToast({
        toastType: "success",
        message: "SoW Approved!",
      });
      navigate("/dashboard")
      setIsModalOpen(false)
    }
  }
  const sowFeedbackButtonProp: ButtonProp = {
    buttonText: "Submit Feedback",
    actionHandler: submitSowFeedback,
  }

  async function submitSowFeedback (updatedForm: FormData) {
    if (sowArray && sowArray.length > 0) {
      const workingSow = sowArray[sowViewingArrayPosition] as T.Statement
      const form = updatedForm as any
      const sowFeedback = form.sowFeedback as string
      showLoading();
      const response = await sendSowFeedback(sowFeedback, workingSow.sowId);
      hideLoading();
      if (response.success) {
        showToast({
          toastType: "success",
          message: "SoW Feedback Requested",
        });
        navigate("/dashboard")
      }
    }
  }

  const project = memberDetailsAsync.value.project

  const getNeedHelpFormDef = (founderProfile: T.StartupFounderProfile, regionalFirmOptions: {value: string, text: string}[]) => {
    const regionalFirmSelectionData = () => {
      const array: {value: string, text: string}[] = []
      regionalFirmOptions.forEach((item) => (
        array.push(
          {value: item.value, 
          text: item.text, 
          }
        )
      ))
      array.push({value: "Other", text: "Other"})
      return array
    }
    
    let modifiedForm = { ...needHelpWithDefinition };
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "topics";
      const newValue: FieldDefinition = {
          label: "Please select the topics that you'd like to discuss with our IP Advisor:",
          frLabel: "",
          inputType: "multiSelect",
          validator: selection_validator,
          conditionalRenderDefinition: {
            fieldKey: "businessGoal",
            renderWhenTrue: true, 
          },
          additionalData: {
            selectionData: [
              {
                value: "Patents",
                text: "Patents",
                frText: "",
              },
              {
                value: "Industrial Designs/ Design Patents",
                text: "Industrial Designs/ Design Patents",
                frText: "",
              },
              {
                value: "Trademarks",
                text: "Trademarks",
                frText: "",
              },
              {
                value: "Trade Secrets",
                text: "Trade Secrets",
                frText: "",
              },
              {
                value: "Copyright",
                text: "Copyright",
                frText: "",
              },
              {
                value: "Open Source Asset Use",
                text: "Open Source Asset Use",
                frText: "",
              },
              {
                value: "IP Strategy",
                text: "IP Strategy",
                frText: "",
              },
              {
                value: "IP Ownership",
                text: "IP Ownership",
                frText: "",
              },
              {
                value: "Freedom to Operate",
                text: "Freedom to Operate",
                frText: "",
              },
            ]
          },
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "businessGoal") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "specificDiscussion";
      const newValue: FieldDefinition = {
        label: "Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor",
        frLabel: "",
        inputType: "textarea",
        conditionalRenderDefinition: {
          fieldKey: "businessGoal",
          renderWhenTrue: true, 
        },
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "topics") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Other")) {
      const newKey = "activitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Other")) {
      const newKey = "patentActivitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator  
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.searchCompleted) {
      const newKey = "searchCompleted";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "yes",
              text: "Yes",
              frText: "Oui",
            },
            {
              value: "no",
              text: "No",
              frText: "Non",
            },
            {
              value: "n/a",
              text: "N/A",
              frText: "N/A",
            }
          ]
        },     
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Patent Filing")) {
      const newKey = "patentsReadyOptions";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        frLabel: "",
        inputType: "multiSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "",
            },
            {
              value: "I have a granted patent in the same patent family.",
              text: "I have a granted patent in the same patent family.",
              frText: "",
            },
            {
              value: "I have received a favorable written opinion from my PCT application.",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "",
            },
            {
              value: "None of the Above",
              text: "None of the Above",
              frText: "",
            }
          ]
        },
      };
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.exclusiveRights) {
        const newKey = "exclusiveRights";
        const newValue: FieldDefinition = {
          label: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
          frLabel: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
  
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Trademark Filing")) {
        const newKey = "searchCompleted";
        const newValue: FieldDefinition = {
          label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "yes",
                text: "Yes",
                frText: "Oui",
              },
              {
                value: "no",
                text: "No",
                frText: "Non",
              },
              {
                value: "n/a",
                text: "N/A",
                frText: "N/A",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }
  
      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm) {
        const newKey = "firmId";
        const newValue: FieldDefinition = {
          label: `Please select the firm (select "Other" if your current firm is not listed)`,
          frLabel: "",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: regionalFirmSelectionData()
          },
          };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "workingWithFirm") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm && founderProfile.needHelpWith.firmId === "Other" && founderProfile.needHelpWith.firmOther) {
        const newKey = "firmOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator    
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "firmId") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport) {
        const newKey = "supportOrg";
        const newValue: FieldDefinition = {
          label: `Please select which organization:`,
          frLabel: "Veuillez préciser quelle organisation:",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Intellectual Property Ontario (IPON)",
                text: "Intellectual Property Ontario (IPON)",
                frText: "",
              },
              {
                value: "IP Assist",
                text: "IP Assist",
                frText: "",
              },
              {
                value: "Other",
                text: "Other",
                frText: "",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "govtSupport") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport && founderProfile.needHelpWith.supportOrg === "Other" && founderProfile.needHelpWith.supportOrgOther) {
        const newKey = "supportOrgOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator        
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "supportOrg") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

    return modifiedForm
  }

  const companyInfoToForm = (info: T.CompanyInfo) => {
    return flattenObject({basicInfo: info.basicInfo, registration: info.registration})
  }

  const sowFeedbackHTML = (
    <Form 
      formDefinition={sowFeedbackFormDefinition}
      formData={null}
      primaryButtonProp={sowFeedbackButtonProp}
    />
  )

  const addFeedbackNote = () => {
    setModalHtml(
      <div className="w-full flex flex-col gap-4">
        <h4>Add Your Change Requests</h4>
        <Form 
          formDefinition={sowFeedbackExpertFormDefinition}
          formData={null}
          primaryButtonProp={sowFeedbackButtonProp}
        />
      </div>
    )
  }

  let sowArray: T.Statement[] | undefined = []

  sowArray = memberDetailsAsync.value.project?.statements.filter(obj => !obj.hasOwnProperty('expertApprovedDate'));

  const viewSow = () => {
    setViewingSow(true)
    if (sowArray && sowArray.length > 0) {
      const workingSow = sowArray[sowViewingArrayPosition] as T.Statement
      const combinedArray = [...workingSow.sowItems as T.SowItem[], ...workingSow.payment as T.Payment[]];
      const sortedArray = combinedArray.sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime());
      const isTier2 = workingSow.tier === "2" 
      setWorkingSowId(workingSow.sowId)
      const percentage = memberDetailsAsync.value.coInvestPercentage 
      const generateSowItemTableHtml = () => {
        const html = sortedArray.map((item, index) => {
        if (item.hasOwnProperty('category')) {
          const {category, task, taskDescription, deliverable, itemDate, costBreakdown, costBreakdownTotalTax, costBreakdownTotal, itemId} = item as T.SowItem;
          return (
            <div key={itemId} className="w-full flex gap-2 relative mb-4 mt-4  border-cSage border-b-[1px]">
              <div className="h-full flex flex-col justify-between" style={{ width: '15%', display: 'inline-flex' }}>
                <div className="mb-4">
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize">{category}</p>
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize mt-2">{task}</p>
                </div>
              </div>
              <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                <p className="">{taskDescription}</p>
              </div>
              <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                <p className="">{deliverable}</p>
              </div>
              {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                <p className="">{effort}</p>
              </div> */}
              <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
              </div>
              <div className="h-full mb-4" style={{ width: '24%', display: 'inline-block' }}>
                <ul className="w-full">
                  {costBreakdown.map((expense, index) => (
                    <li key={index} className={index === 0 ? `expenseLi w-full !p-0 border-1 border-b mb-2 border-cSage` : "expenseLi border-1 border-b !p-0 mb-2 border-cSage"}>
                      <div>
                        {expense.itemDescription}
                      </div> 
                      {
                        !expense.isLumpsum &&
                        <div className="flex w-full bodySmaller">
                          <span className="w-1/3">Hours: {expense.effort}</span>
                          <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                        </div>                           
                      }
                      <div className="flex w-full bodySmaller pb-2">
                        <span className="w-1/3">$ {expense.amount}</span>
                        <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="flex flex-col gap-1">
                  <p className="">Pre-Tax: ${costBreakdownTotal.toFixed(2)}</p>
                  <p className="">Tax: ${costBreakdownTotalTax.toFixed(2)}</p>
                  <p className=""><span className="font-semibold">Total: </span>${(costBreakdownTotal + costBreakdownTotalTax).toFixed(2)}</p>
                </div>
              </div>
            </div>
          );
        } else if (item.hasOwnProperty('paymentType')) {
            const {paymentType, itemDate, coInvestDate, paymentAmount, itemId, preTax, tax} = item as T.Payment
            if (paymentType === "milestone") {
              return (
                <div key={itemId} className="w-full pb-4 mb-4 gap-2 flex border-cSage border-b-[1px]">
                  <div className="h-full flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold mb-2">Progress Milestone Payment</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="">{`Pre-Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
                </div>
              );
            } else if (paymentType === "final" && isTier2) {
              return (
                <div key={itemId} className="w-full gap-2 flex pb-4 mb-4 border-cSage border-b-[1px]">
                  <div className="h-full items-center flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold mb-2">Final Payment</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '14%', display: 'inline-flex' }}>
                    <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
              </div>
              )
            } else if (paymentType === "final" && !isTier2 && coInvestDate) {
              return (
                <div className="w-full mb-4 gap-2 flex flex-col border-cSage border-b-[1px]">
                  <div key={itemId} className="w-full gap-2 flex">
                    <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold mb-2">Final Payment</p>
                    </div>
                    <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                      <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="h-full flex-col gap-2 justify-center border-cSage border-b-[1px]" style={{ width: '24%', display: 'inline-flex' }}>
                      <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                      <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                      <p className="pb-2"><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                    </div>
                  </div>
                  <div className="w-full flex gap-2 py-2">
                    <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold">Co-Invest Payment ({percentage}%)</p>
                    </div>
                    <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                      <p className="">{moment(coInvestDate).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                      <p className=""><span className="font-semibold">{`Total: `}</span> ${preTax ? (percentage / 100 * preTax).toFixed(2) : ""}</p>
                    </div>
                  </div>
                </div>
              )
            } else {
              return <></>
            }
          }
        })
        setModalHtml(
          <div className="flex flex-col">
            {
              workingSow.sowStatus === "Edit Requested from Admin" && workingSow.adminFeedback &&
              <div>
                <div className="font-semibold bodyLarger">{workingSow.adminFeedback.map((note, index) => (
                  <div key={index}>
                    <div className="flex justify-between w-full mb-2">
                      <p>{moment(note.date).format('MMM Do YYYY').toString()}</p>
                    </div>
                    <div className="flex mt-2 mb-2">
                      <span className="notesLine">{note.feedback}</span>
                    </div>
                  </div>
                ))}
                </div>
              </div>
            }
            <div id="sowApproveContainer" className="w-full flex flex-col overflow-y-auto">
              <div className="border-cSage mb-4">
                  <div className="flex flex-col w-full mt-4">
                    <div className="w-full font-medium flex gap-2 bg-backgrounds text-text">
                      <div className="h-full" style={{ width: '15%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Category</p>
                      </div>
                      <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                      </div>
                      <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                      </div>
                      {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                      </div> */}
                      <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                      </div>
                      <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                      </div>
                    </div>
                  </div>
              </div>          
              {html}
            </div>
              <div className="inline-flex gap-4 ">
              {workingSow.sowStatus === "Awaiting Expert Approval" &&
              <div className="flex gap-4">
                <Button
                  buttonText={"Approve SoW"}
                  buttonType='primary'
                  actionHandler={() => approveSoW(workingSow.sowId)}
                />
                <Button
                  buttonText={"Request Changes"}
                  buttonType='secondary'
                  actionHandler={() => addFeedbackNote()}
                />              
              </div>
              }
              {workingSow.sowStatus === "Awaiting Admin Approval" &&
              <div className="flex gap-4">
                <Button
                  buttonText={"Approve SoW"}
                  buttonType='primary'
                  actionHandler={() => approveSoW(workingSow.sowId)}
                />
                <Button
                  buttonText={"Request Changes"}
                  buttonType='secondary'
                  actionHandler={() => addFeedbackNote()}
                />              
              </div>
              }
              {/* <Button
                buttonText={"Request Changes"}
                buttonType='secondary'
                actionHandler={() => setModalHtml(sowFeedbackHTML)}
              /> */}
            </div>
          </div>
        );
        setIsModalOpen(true);
      }
    generateSowItemTableHtml()
  }
  } 

  return (
    <div className="resourcesCont !pt-0 w-full flex !flex-row !justify-between switchFlex overflow-y-auto">
      {isNdaModalOpen &&
      <div className="flex flex-col w-full largeModal">
        <div className="flex flex-col w-full mediumModalInner">
          <div className='flex justify-end w-full'>
            <button onClick={() => setIsNdaModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
          </div>
            <NDAUpload appId={appId} handlePdfStateChange={handlePdfStateChange} />
        </div>
      </div>
      }
      <div className="memDetailsCont1">
        <div>
          <div className="flex flex-col mb-4">
          {applicationDetails?.profileSnapshot.companyInfo?.basicInfo ?
          <div>
            <h2 className="mb-8">{applicationDetails?.profileSnapshot.companyInfo.basicInfo.operatingName}</h2>
            {websiteHtml}
            <p className="">{applicationDetails?.profileSnapshot.companyInfo?.basicInfo?.description}</p>
          </div>
          :
          <p>Startup has not completed Company Information</p>
          }
          </div>
          { 
          applicationDetails && applicationDetails.profileSnapshot.personalInfo ?
          <div className="flex flex-col gap-2">
            <p className="bodyLarger font-semibold">{`${applicationDetails.profileSnapshot.personalInfo?.firstName} ${applicationDetails.profileSnapshot.personalInfo?.lastName} `}<span className=" font-normal">{`(${applicationDetails.profileSnapshot.personalInfo?.pronouns})`}</span></p>
            <p className="">{applicationDetails.profileSnapshot.personalInfo.title}</p>
            <p className=" flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M0.976621 0.000509719C0.700221 0.00156869 0.459824 0.129712 0.282949 0.304455C0.108208 0.54168 -0.00510934 0.777847 0.000177378 1.00873C0.139969 5.09143 1.42987 8.35727 3.76188 10.591C6.09707 12.8277 9.45311 14.0076 13.6491 14C13.9192 13.9629 14.1808 13.8464 14.3481 13.6854C14.525 13.5107 14.6616 13.2745 14.6626 12.997C14.6701 12.0248 14.6775 11.0505 14.6838 10.0782C14.6764 9.80605 14.5419 9.58048 14.364 9.41103C14.1861 9.24159 13.9478 9.11558 13.6703 9.11769C12.7564 9.12087 11.5342 8.80209 10.5493 8.55746C10.437 8.52887 10.312 8.56275 10.2294 8.64324L8.50107 10.3186C6.39782 9.06792 5.4795 8.17622 4.19497 6.13536L5.91272 4.47056C5.99956 4.38583 6.03556 4.25134 6.0038 4.13484C5.74115 3.15099 5.28895 1.84097 5.36307 0.869812C5.3493 0.60611 5.12267 0.369932 4.95217 0.240747C4.77213 0.10625 4.53384 -0.00706801 4.25321 0.000344244H0.977615L0.976621 0.000509719ZM0.976621 0.683581H4.26822C4.34447 0.680404 4.44719 0.720648 4.54039 0.790544C4.62299 0.851967 4.67488 0.928218 4.68971 0.950458C4.64205 2.05609 5.03706 3.23164 5.287 4.12005L3.51522 5.84311C3.40296 5.95008 3.37966 6.13857 3.46227 6.2699C4.91422 8.62415 5.9563 9.63334 8.3762 11.045C8.50329 11.1202 8.68015 11.1001 8.78711 10.9974L10.5695 9.26374C11.5152 9.50202 12.6664 9.80702 13.6745 9.80279C13.7285 9.80279 13.8217 9.83668 13.8938 9.90446C13.9647 9.97224 13.9997 10.0612 14.0007 10.0961L13.9795 12.9938C13.9795 13.0372 13.9456 13.1294 13.8726 13.2014C13.7995 13.2734 13.6936 13.3147 13.6269 13.3189C9.57074 13.3221 6.41795 12.1868 4.2363 10.0962C2.05044 8.00141 0.814572 4.92715 0.683353 0.967256C0.68653 0.888888 0.740542 0.838053 0.769136 0.791454C0.825265 0.727911 0.912105 0.710966 0.976709 0.684492L0.976621 0.683581Z" fill="#1A2E25"/></svg>
              {applicationDetails.profileSnapshot.personalInfo.phoneNumber}
            </p>
            <p className=" flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="21" height="14" viewBox="0 0 21 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.643217 0.98439C2.48353 2.62505 4.23794 4.12706 5.56312 5.24541C6.28 5.84952 6.87069 6.34091 7.28344 6.68229C7.43758 6.81057 7.56688 6.91712 7.66826 6.99987C4.25759 9.80223 3.87174 10.1457 0.780714 12.8954C0.735196 12.9357 0.688645 12.9761 0.64313 13.0174C0.582096 10.1012 0.552096 8.55066 0.552096 6.99985C0.552096 5.44904 0.582183 3.89957 0.643217 0.98439ZM1.09424 13.3546C5.59016 13.4167 7.9508 13.4477 10.3104 13.4477C12.6741 13.4477 15.038 13.4167 19.5482 13.3546C16.3672 10.4095 16.03 10.1115 12.5262 7.35765L11.2186 8.5028C10.6983 8.95798 9.92241 8.95798 9.40206 8.5028L8.09759 7.36178C4.62283 10.2168 4.2587 10.5407 1.1502 13.3047C1.13158 13.3212 1.11286 13.338 1.09424 13.3546ZM8.27766 6.78573C8.28076 6.7878 8.28283 6.78987 8.2849 6.79194L9.76521 8.08709C10.0776 8.36018 10.5431 8.36018 10.8555 8.08709L12.3359 6.79194C12.3379 6.78987 12.341 6.7878 12.3441 6.78573L12.3772 6.75884C12.399 6.74022 12.4321 6.71332 12.4765 6.67712C12.5645 6.6047 12.6969 6.49712 12.8696 6.35435C13.2162 6.06781 13.7283 5.6416 14.3914 5.08195C15.6172 4.04643 17.3603 2.5537 19.5244 0.645087C15.0296 0.583018 12.67 0.551985 10.3104 0.551985C7.94975 0.551985 5.58913 0.58302 1.09136 0.645087C2.89858 2.25368 4.61591 3.72473 5.9191 4.82322C6.63392 5.4263 7.22358 5.91665 7.6353 6.257C7.84012 6.42665 8.0015 6.55906 8.11116 6.64907C8.16495 6.69355 8.20736 6.72872 8.23529 6.75148L8.27766 6.78573ZM19.9775 0.980417C17.77 2.9304 15.9927 4.452 14.7472 5.50414C14.0821 6.06483 13.569 6.49207 13.2214 6.77964C13.119 6.86343 13.0311 6.93584 12.9586 6.99584C16.4106 9.71029 16.7634 10.0249 19.9786 13.001C20.0386 10.0951 20.0686 8.54771 20.0686 7.00008C20.0686 5.44941 20.0385 3.89745 19.9775 0.980417ZM0.375242 0.103188C10.3093 -0.034396 10.3114 -0.034396 20.2452 0.103188C20.3932 0.105257 20.5142 0.225256 20.5173 0.373176C20.6549 6.99801 20.6549 7.00199 20.5173 13.6268C20.5142 13.7748 20.3932 13.8947 20.2452 13.8968C10.3112 14.0344 10.3091 14.0344 0.375242 13.8968C0.227314 13.8947 0.106286 13.7747 0.103188 13.6268C-0.034396 7.00199 -0.034396 6.99801 0.103188 0.373176C0.106291 0.225248 0.227324 0.105254 0.375242 0.103188Z" fill="#1A2E25"/></svg>
              {memberDetails.email}
            </p>
          </div>
          :
          <p>Startup has not completed Personal Information</p>
          }
        </div>
        <Accordion
            allowZeroExpanded={true}
            className="w-full"
            >    
            <AccordionItem
                uuid={0}
                className=""
                key={`0`}
                >
                <AccordionItemHeading>
                  <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                    <p className="font-semibold bodyLarger">Scoring</p>
                    <AccordionItemState>
                    {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  {applicationDetails && applicationDetails.ipPreScore && applicationDetails.applicationScore &&
                    <h4 className="font-semibold bodyLarger mt-4">Total Score: {applicationDetails.ipPreScore.totalScore + applicationDetails.applicationScore.totalScore}</h4>
                  }
                  {applicationDetails && applicationDetails.ipPreScore === undefined && applicationDetails.applicationScore &&
                    <h4 className="font-semibold bodyLarger mt-4">Total Score: {applicationDetails.applicationScore.totalScore}</h4>
                  }
                    <div className="flex flex-col w-full mt-4">
                      <p className="text-xl bodyLarger font-semibold">Persona Score: {applicationDetails?.applicationScore?.totalScore}</p>
                      <ul className="ml-2 list-disc">
                        <li>Classification: {applicationDetails?.applicationScore?.classification}</li>
                        <li>Age Score: {applicationDetails?.applicationScore?.age}</li>
                        <li>Revenue Score: {applicationDetails?.applicationScore?.revenue}</li>
                        <li>Employee Score: {applicationDetails?.applicationScore?.fte}</li>
                      </ul>
                    </div>
                    {
                    applicationDetails && applicationDetails.ipPreScore &&
                    <div className="flex flex-col w-full mt-4">
                      <p className="bodyLarger font-semibold">IP PreScore: {applicationDetails?.ipPreScore?.totalScore}</p>
                      <ul className="ml-2 list-disc">
                        <li>IP Readiness - Patents: {applicationDetails?.ipPreScore?.ipReadinessPatents}</li>
                        <li>IP Readiness - General: {applicationDetails?.ipPreScore?.ipReadinessGeneral}</li>
                      </ul>
                    </div>
                    }
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem
                uuid={1}
                className=""
                key={`1`}
                >
                <AccordionItemHeading>
                    <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                      <p className="font-semibold bodyLarger">Program Application</p>
                      <AccordionItemState>
                      {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                <AccordionItemPanel>
                {applicationDetails ?
                    <div className="mt-4">                  
                    <div className="flex flex-col applicationFormWidth">
                      <h4 className="mb-6">Personal Info</h4>
                      <Form
                        formDefinition={profileFormPersonalInfoDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.personalInfo ? applicationDetails?.profileSnapshot.personalInfo : null}
                        readOnly
                        disabled
                      />
                      <h4 className="mb-6 mt-8">Company Info</h4>
                      {applicationDetails &&
                        <Form
                        formDefinition={getModifiedCompanyInfoFormDef(applicationDetails.profileSnapshot)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.companyInfo ? companyInfoToForm(applicationDetails?.profileSnapshot.companyInfo) : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Need Help With</h4>
                      {applicationDetails &&
                      <Form
                        formDefinition={getNeedHelpFormDef(applicationDetails.profileSnapshot, memberDetailsAsync.value.providersArray)}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.needHelpWith ? applicationDetails?.profileSnapshot.needHelpWith : null}
                        readOnly
                        disabled
                      />
                      }
                      <h4 className="mb-6 mt-8">Community, Culture & Climate</h4>
                      <Form
                        formDefinition={profileFormAdminProgramingEvaluationDefinition}
                        formData={applicationDetails?.profileSnapshot && applicationDetails?.profileSnapshot.programingEvaluation ? applicationDetails?.profileSnapshot.programingEvaluation : null}
                        readOnly
                        disabled
                      />
                    </div>
                    </div>
                    :
                    <p className="mt-4">No application has been submitted</p>
                    }

                </AccordionItemPanel>
              </AccordionItem>
              {applicationDetails && applicationDetails.growthCoach &&
              <AccordionItem
                uuid={5}
                className=""
                key={`5`}
                >
                <AccordionItemHeading>
                  <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                    <p className="font-semibold bodyLarger">Growth Coach</p>
                    <AccordionItemState>
                    {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <div className="flex flex-col w-full mt-4 gap-4">
                      {applicationDetails.growthCoach.gcName &&
                      <p className="bodyLarger font-semibold">Growth coach: {applicationDetails.growthCoach.gcName}</p>
                      }
                      {applicationDetails.growthCoach.status &&
                      <p className="bodyLarger font-semibold">Status: {applicationDetails.growthCoach.status}</p>
                      }
                      {applicationDetails.growthCoach.declineReason &&
                      <p className="bodyLarger font-semibold">Declined Reason: {applicationDetails.growthCoach.declineReason}</p>
                      }
                      {applicationDetails.growthCoach.rejectionNote &&
                      <p className="bodyLarger font-semibold">REjection Note: {applicationDetails.growthCoach.rejectionNote}</p>
                      }
                      {applicationDetails.growthCoach.timeSpent &&
                      <p className="bodyLarger font-semibold">Time Spent: {applicationDetails.growthCoach.timeSpent}</p>
                      }
                      {applicationDetails.growthCoach.inviteDate &&
                      <p className="bodyLarger font-semibold">Invite Date: {moment(applicationDetails.growthCoach.inviteDate).format('MMM Do YYYY').toString()}</p>
                      }
                      {applicationDetails.growthCoach.assessmentSubmitDate &&
                      <p className="bodyLarger font-semibold">Assement Submitted: {moment(applicationDetails.growthCoach.assessmentSubmitDate).format('MMM Do YYYY').toString()}</p>
                      }
                    </div>
                </AccordionItemPanel>
              </AccordionItem>
              }
              {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.expertMeetings && applicationDetails.expertAssessment.expertMeetings.length > 0 &&
                <AccordionItem
                  uuid={2}
                  className=""
                  key={`2`}
                >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">IP Expert Meetings</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                  {
                      applicationDetails.expertAssessment.expertMeetings.map((meeting) => (
                        <div className="w-full flex flex-col gap-2 my-2 border-b">
                          <div className="w-full flex justify-between items-center my-2">
                            <p className="flex justify-between items-center">
                              <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="15" height="14" viewBox="0 0 15 14" fill="none"><path d="M0.976621 0.000509719C0.700221 0.00156869 0.459824 0.129712 0.282949 0.304455C0.108208 0.54168 -0.00510934 0.777847 0.000177378 1.00873C0.139969 5.09143 1.42987 8.35727 3.76188 10.591C6.09707 12.8277 9.45311 14.0076 13.6491 14C13.9192 13.9629 14.1808 13.8464 14.3481 13.6854C14.525 13.5107 14.6616 13.2745 14.6626 12.997C14.6701 12.0248 14.6775 11.0505 14.6838 10.0782C14.6764 9.80605 14.5419 9.58048 14.364 9.41103C14.1861 9.24159 13.9478 9.11558 13.6703 9.11769C12.7564 9.12087 11.5342 8.80209 10.5493 8.55746C10.437 8.52887 10.312 8.56275 10.2294 8.64324L8.50107 10.3186C6.39782 9.06792 5.4795 8.17622 4.19497 6.13536L5.91272 4.47056C5.99956 4.38583 6.03556 4.25134 6.0038 4.13484C5.74115 3.15099 5.28895 1.84097 5.36307 0.869812C5.3493 0.60611 5.12267 0.369932 4.95217 0.240747C4.77213 0.10625 4.53384 -0.00706801 4.25321 0.000344244H0.977615L0.976621 0.000509719ZM0.976621 0.683581H4.26822C4.34447 0.680404 4.44719 0.720648 4.54039 0.790544C4.62299 0.851967 4.67488 0.928218 4.68971 0.950458C4.64205 2.05609 5.03706 3.23164 5.287 4.12005L3.51522 5.84311C3.40296 5.95008 3.37966 6.13857 3.46227 6.2699C4.91422 8.62415 5.9563 9.63334 8.3762 11.045C8.50329 11.1202 8.68015 11.1001 8.78711 10.9974L10.5695 9.26374C11.5152 9.50202 12.6664 9.80702 13.6745 9.80279C13.7285 9.80279 13.8217 9.83668 13.8938 9.90446C13.9647 9.97224 13.9997 10.0612 14.0007 10.0961L13.9795 12.9938C13.9795 13.0372 13.9456 13.1294 13.8726 13.2014C13.7995 13.2734 13.6936 13.3147 13.6269 13.3189C9.57074 13.3221 6.41795 12.1868 4.2363 10.0962C2.05044 8.00141 0.814572 4.92715 0.683353 0.967256C0.68653 0.888888 0.740542 0.838053 0.769136 0.791454C0.825265 0.727911 0.912105 0.710966 0.976709 0.684492L0.976621 0.683581Z" fill="#1A2E25"/></svg>
                              {moment(meeting.date).format('MMM Do YYYY').toString()}
                            </p>
                            <p>{meeting.duration} minutes</p>
                            <p>{daysAgo(meeting.date)} days ago</p>
                          </div>
                          <p className="font-semibold">{meeting.meetingType}</p>
                          <p className="pb-2">{meeting.notes}</p>
                        </div>
                      ))
                      }
                  </AccordionItemPanel>
                </AccordionItem>
                }
                {applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.complete && applicationDetails.expertAssessment.notes &&
                <AccordionItem
                  uuid={3}
                  className=""
                  key={`3`}
                  >
                  <AccordionItemHeading>
                      <AccordionItemButton className="flex memDetailsAccButt items-center py-4 justify-between border-b border-cSage">
                        <p className="font-semibold bodyLarger">IP Expert Assessment</p>
                        <AccordionItemState>
                        {({ expanded }) => (expanded ? <img src={Minus} alt="collapse"/> : <img src={Plus} alt="expand"/>)}
                        </AccordionItemState>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                  <AccordionItemPanel>
                    <Form 
                      formDefinition={adminRecommendationFormDefition}
                      formData={ipeRecformData}
                      readOnly={true}
                      disabled={true}
                    />
                  </AccordionItemPanel>
                </AccordionItem>
              }
            </Accordion>
          {html}
      </div>
      <div className={`memDetailsExpertCont2 ${isAssessing && "!max-w-full !w-full"}`}>
      {viewingComplete && applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipRejectionObj &&
        <div>
          <div className="flex w-full flex-col gap-4">
            <button onClick={() => handleBack()} className="underline mb-4 flex items-center">
              <span className="rotate-180 mr-2"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1 0.5L6 5.5L1 10.5" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
              Return
            </button>
            <h4 className="">Reasoning:</h4>
            <div className="w-full inline-flex flex-wrap">
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={hardCrit}
                    disabled={true}
                  />
                  <span className="ml-2">Hard Criteria</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={notTech}
                    disabled={true}
                  />
                  <span className="ml-2">Not Technology</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={economicBenefit}
                    disabled={true}
                  />
                  <span className="ml-2">Economic Benefit</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={revScore}
                    disabled={true}
                  />
                  <span className="ml-2">Revenue Source</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={marketReadiness}
                    disabled={true}
                  />
                  <span className="ml-2">Market Readiness</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={ipOwnership}
                    disabled={true}
                  />
                  <span className="ml-2">IP Ownership</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={commercialization}
                    disabled={true}
                  />
                  <span className="ml-2">Commercialization</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={jobCreation}
                    disabled={true}
                  />
                  <span className="ml-2">Job Creation</span>
                </label>
              </div>
              <div className="flex bodyLarger my-2">
                <label className="flex items-center h-full align-center">
                  <input
                    type="checkbox"
                    checked={teamFit}
                    disabled={true}
                  />
                  <span className="ml-2">Team Fit</span>
                </label>
              </div>
            </div>  
          </div>
        </div>
      }
      {viewingComplete && applicationDetails && applicationDetails.expertAssessment && applicationDetails.expertAssessment.ipAssessmentObj && 
        <div className="overflow-y-auto flex flex-col w-full">
          <button onClick={() => handleBack()} className="underline mb-4 flex items-center">
            <span className="rotate-180 mr-2"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1 0.5L6 5.5L1 10.5" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
            Return
          </button>
          <p className="font-semibold bodyLarger">Tier 1 - Education and Awareness</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t1Rec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <Form 
            readOnly={true}
            disabled={true}
            formDefinition={t1AssessmentForm}
            formData= {{
              t1Rec: applicationDetails.expertAssessment.ipAssessmentObj.t1Rec || "",
              t1Score: applicationDetails.expertAssessment.ipAssessmentObj.t1Score || "",
              t1Notes: applicationDetails.expertAssessment.ipAssessmentObj.t1Notes || "",
            }}
          />
          }
          <p className="font-semibold bodyLarger">Tier 2 - Coaching</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <Form 
            readOnly={true}
            disabled={true}
            formDefinition={t2CoachAssessmentForm}
            formData= {{
              t2CoachRec: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachRec || "",
              t2CoachScore: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachScore || "",
              t2CoachNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2CoachNotes || "",
            }}
          />
          }
          <p className="font-semibold bodyLarger">Tier 2 - Service</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <div className="w-full flex flex-col gap-2">
            <Form
              readOnly={true}
              disabled={true} 
              formDefinition={t2ServiceAssessmentForm}
              formData= {{
                t2ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceRec || "",
                t2ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceScore || "",
                t2ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceNotes || "",
              }}
              />
              {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.length > 0 &&
                <ul className="">
                  {applicationDetails.expertAssessment.ipAssessmentObj.t2ServiceArray.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              }
          </div>
          }
          <p className="font-semibold bodyLarger">Tier 3 - Service</p>
          {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec === "n/a" ?
            <div className="flex flex-col w-full mb-4">
              Not Applicable
            </div>
          :
          <div className="w-full flex flex-col gap-2">
            <Form 
              readOnly={true}
              disabled={true}
              formDefinition={t3serviceAssessmentForm}
              formData= {{
                t3ServiceRec: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceRec || "",
                t3ServiceScore: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceScore || "",
                t3ServiceNotes: applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceNotes || "",
              }}
            />
            {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray && applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.length > 0 &&
            <ul className="">
              {applicationDetails.expertAssessment.ipAssessmentObj.t3ServiceArray.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            }
          </div>
            }
        </div>
      }
      {isAssessing ?
      <div className="overflow-y-auto flex flex-col w-full">
        <button onClick={() => handleBack()} className="underline mb-4 flex items-center">
          <span className="rotate-180 mr-2"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1 0.5L6 5.5L1 10.5" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          Return without saving
        </button>
        <div className="flex flex-col">
          {enteringMeeting &&
            <div className="flex flex-col">
              <Form
                formData={null}
                formDefinition={ipeMeetingForm}
                primaryButtonProp={meetingButtonProp}
              />
            </div>  
          }
          {submitRec &&
            recHtml
          }
          {rejecting &&
            <div className="flex w-full flex-col gap-4">
              <h4 className="">Reasoning:</h4>
                <div className="w-full inline-flex flex-wrap">
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={hardCrit}
                        onChange={() => changeCriteria("hardCrit")}
                      />
                      <span className="ml-2">Hard Criteria</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={notTech}
                        onChange={() => changeCriteria("notTech")}
                      />
                      <span className="ml-2">Not Technology</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={economicBenefit}
                        onChange={() => changeCriteria("economicBenefit")}
                      />
                      <span className="ml-2">Economic Benefit</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={revScore}
                        onChange={() => changeCriteria("revScore")}
                      />
                      <span className="ml-2">Revenue Source</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={marketReadiness}
                        onChange={() => changeCriteria("marketReadiness")}
                      />
                      <span className="ml-2">Market Readiness</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={ipOwnership}
                        onChange={() => changeCriteria("ipOwnership")}
                      />
                      <span className="ml-2">IP Ownership</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={commercialization}
                        onChange={() => changeCriteria("commercialization")}
                      />
                      <span className="ml-2">Commercialization</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={jobCreation}
                        onChange={() => changeCriteria("jobCreation")}
                      />
                      <span className="ml-2">Job Creation</span>
                    </label>
                  </div>
                  <div className="flex bodyLarger my-2">
                    <label className="flex items-center h-full align-center">
                      <input
                        type="checkbox"
                        checked={teamFit}
                        onChange={() => changeCriteria("teamFit")}
                      />
                      <span className="ml-2">Team Fit</span>
                    </label>
                  </div>
                </div>  
                <div className='flex flex-col text-text gap-4 '>
                  <Button
                    actionHandler={() => saveRejection(false)}
                    buttonText="Save Progress"
                    buttonType="secondary"
                  />
                  <Button
                    actionHandler={() => saveRejection(true)}
                    buttonText="Submit Rejection"
                    buttonType="primary"
                  />
                </div>
              </div>
          }
          {!rejecting && !submitRec && !enteringMeeting && !viewingComplete &&
          <div className='flex flex-col text-text gap-4'>
            <Button
              actionHandler={() => setEnteringMeeting(true)}
              buttonText="Enter Interaction"
              buttonType="primary"
            />
            <Button
              actionHandler={() => setSubmitRec(true)}
              buttonText="Submit Recommendation"
              buttonType="primary"
            />
            {/* <Button
              actionHandler={() => rejectProgCheck()}
              buttonText="Reject Application"
              buttonType="secondary"
            /> */}
            </div>
          }
        </div>
      </div>
      :
      <div className="w-full">
        {!rejecting && !submitRec && !enteringMeeting && !viewingComplete &&
        <div className="w-full">
          {
            founderStatus === "awaitingIpe" &&
            <div className="flex flex-col w-full">
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="redCircle"></span>
                <p>New Assessment Request</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="Initial Meeting Invitation"
                  actionHandler={() => {handleInvite()}}
                  buttonType="primaryFull"
                />
                <Button
                  buttonText="Conflict of Interest"
                  actionHandler={() => {setIsModalOpen(true), setModalHtml(conflictOfInterestModalHTML)}}
                  buttonType="primaryFull"
                />
              </div>
            </div>
          }
          {
            founderStatus === "ipExpertInvite" &&
            <div className="flex flex-col">
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-4">
                <span className="orangeCircle"></span>
                <p>Invite Sent</p>
              </div>
              <p className="mb-4">Company invite sent on {moment(applicationDetails?.expertAssessment?.inviteDate).format('MMM Do YYYY').toString()}</p>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="Begin Assessment"
                  actionHandler={() => {setIsAssessing(true)}}
                  buttonType="primaryFull"
                />
                <Button
                  buttonText="Conflict of Interest"
                  actionHandler={() => {setIsModalOpen(true), setModalHtml(conflictOfInterestModalHTML)}}
                  buttonType="primaryFull"
                />
                {applicationDetails && applicationDetails.nda === undefined &&
                  <Button
                    buttonText="Upload NDA"
                    actionHandler={() => {setIsNdaModalOpen(true)}}
                    buttonType="secondaryFull"
                  />
                }
                
                <Button
                  buttonText="Pending Board Review"
                  actionHandler={() => {boardReview()}}
                  buttonType="secondaryFull"
                />
              </div>
            </div>
          }
          {
            founderStatus === "ipeBoardReview" &&
            <div className="flex flex-col">
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="purpleCircle"></span>
                <p>Board Review</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
              <Button
                  buttonText="Remove Board Review"
                  actionHandler={() => {removeReview()}}
                  buttonType="secondaryFull"
                />
              </div>
            </div>
          }
          {
            founderStatus === "ipExpertInProgress" &&
            <div className="flex flex-col">
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="purpleCircle"></span>
                <p>Ongoing Assessment</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="Continue Assessment"
                  actionHandler={() => checkAndDisplayProgress()}
                  buttonType="primaryFull"
                />
                <Button
                  buttonText="Conflict of Interest"
                  actionHandler={() => {setIsModalOpen(true), setModalHtml(conflictOfInterestModalHTML)}}
                  buttonType="primaryFull"
                />
                {/* <Button
                  buttonText="Flag for Due Diligence"
                  actionHandler={() => {setIsModalOpen(true), setModalHtml(flagModalHTML)}}
                  buttonType="primaryFull"
                /> */}
              </div>
            </div>
          }
          {
            founderStatus === "ipExpertRecommendation" && 
            <div className="flex flex-col"> 
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="pinkCircle"></span>
                <p>Submitted Assessment</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="View Assessment"
                  actionHandler={() => {viewComplete()}}
                  buttonType="primaryFull"
                />
              </div>
            </div>
          }
          {
            founderStatus === "complete" &&
            <div className="flex flex-col"> 
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="greenCircle"></span>
                <p>Complete</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="View Assessment"
                  actionHandler={() => {viewComplete()}}
                  buttonType="primaryFull"
                />
              </div>
            </div>
          }
          {
            founderStatus === "SoW Awaiting Approval" &&
            <div className="flex flex-col"> 
            {sowArray && sowArray.length > 1 &&
              <div className="flex flex-col w-full gap-2 mb-4">
                <p className="bodyLarger font-semibold">This company has Multiple SoWs in this project</p>
                <div className="flex w-full">
                  <button className={sowViewingArrayPosition === 0 ? `font-semibold underline p-2` : `underline p-2`} onClick={() => setSowViewingArrayPostion(0)}>Statement 1</button>
                  <button className={sowViewingArrayPosition === 1 ? `font-semibold underline p-2` : `underline p-2`} onClick={() => setSowViewingArrayPostion(1)}>Statement 2</button>
                </div>
              </div>
            }
            {project &&
            <div>
            {
            project?.statements[sowViewingArrayPosition].sowStatus === "Awaiting Expert Approval" &&
            <div>
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="blueCircle"></span>
                <p>SoW Expert Approval</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="View SoW"
                  actionHandler={() => {viewSow()}}
                  buttonType="primaryFull"
                />
              </div>
            </div>
            }
            {
            project?.statements[sowViewingArrayPosition].sowStatus === "Awaiting Admin Approval" && project?.statements[sowViewingArrayPosition].expertApprovedDate === undefined &&
            <div>
              <h4 className="mb-4">Status:</h4>
              <div className="flex w-full items-center mb-8">
                <span className="blueCircle"></span>
                <p>SoW Awaiting Approval</p>
              </div>
              <div className="flex flex-col gap-4 w-full mb-8">
                <Button
                  buttonText="View SoW"
                  actionHandler={() => {viewSow()}}
                  buttonType="primaryFull"
                />
              </div>
            </div>
            }                        
            </div>
            }
            </div>
          }
        </div>
        }
        <div className="memDetailsCont2Inner">
          <div className="flex justify-between w-full">
            <div className="w-1/2">
              <p className="font-semibold">Application Date</p>
              <p className="">{applicationDate}</p>
            </div>
            <div className="w-1/2">
              <p className="font-semibold">Invite Date</p>
              <p className="">{inviteDate}</p>
            </div>
          </div>
          <div className="flex justify-between w-full">
            <div className="w-1/2">
              <p className="font-semibold">Updated at</p>
              <p className="">{updateDate}</p>
            </div>
            <div className="w-1/2">
              <p className="font-semibold">Assessed</p>
              <p className="">{assessed}</p>
            </div>
          </div>
          <div className="flex justify-between w-full">
            <div className="w-1/2">
              <p className="font-semibold">Cohort</p>
              <p className="">{applicationDetails && applicationDetails.cohort ? applicationDetails.cohort : "N/A"}</p>
            </div>
            <div className="w-1/2">
              <p className="font-semibold">Owner</p>
              <p className="">{owner}</p>
            </div>
          </div>
          <div className="flex justify-between w-full">
            <div className="w-1/2">
              <p className="font-semibold">Tier</p>
              <p className="">TO DO</p>
            </div>
            <div className="w-1/2">
              <p className="font-semibold">Service Provider</p>
              <p className="">TO DO</p>
            </div>
          </div>
          <div className="flex flex-col w-full">
            <p className="bodyLarger font-semibold w-full">Files</p>
            {docHtml}
          </div>
        </div>
      </div>
      }
        <Modal 
          isOpen={isModalOpen} 
          closeModal={() => handleCloseModal()}
          modalHTML={modalHtml} 
          contentLabel={"Would you like to save your progress or submit your Recommendation?"}
          style={
            viewingSow ? 
            {content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              width: '90%',
              maxWidth: `90vw`,
              maxHeight: '90%',
              background: "background",
            }}
            :
            {content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              minWidth: '300px',
              width: 'full',
              background: "background",
            }}
          }
        />
      </div>
    </div>
  )
}

export default FounderAssesmentDetails